function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["renderSuggestionList", "classes"],
  _excluded2 = ["classes", "defaultInputValue", "delay", "emptyLabel", "idKey", "labelKey", "onInputChange", "onSearch", "renderSuggestion", "renderSuggestionList", "suggestions", "searchText", "fieldClasses"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty2(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import React, { Component } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import noop from "lodash/noop";
import { withClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import Field from "../../../Field/index.js";
import SuggestionContainer from "../SuggestionContainer/index.js";
import SuggestionList from "../SuggestionList/index.js";
import { DOWN, UP, RETURN, ESC, TAB } from "../../utils/keyCode.js";
import labelize from "../../utils/labelize.js";
import styles from "../../styles.css";
var AsyncTypeahead = /*#__PURE__*/function (_Component) {
  _inherits(AsyncTypeahead, _Component);
  var _super = _createSuper(AsyncTypeahead);
  function AsyncTypeahead(props) {
    var _this;
    _classCallCheck(this, AsyncTypeahead);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var container = e.currentTarget;
      var focusedElement = e.relatedTarget;
      if (!container.contains(focusedElement)) {
        _this.hideSuggestions();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "inputRef", function (input) {
      _this.input = input;
    });
    _defineProperty(_assertThisInitialized(_this), "hideSuggestions", function () {
      _this.setState({
        showSuggestions: false,
        activeIndex: -1
      });
    });
    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      var query = _this.state.query;
      _this.input.focus();
      _this.input.setSelectionRange(query.length, query.length);
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var query = e.target.value;
      _this.setState({
        showSuggestions: true,
        activeIndex: -1
      });
      _this.updateQuery(query);
      _this.handleSearchDebounced(_trimInstanceProperty(query).call(query));
    });
    _defineProperty(_assertThisInitialized(_this), "handleSuggestionTabover", function (e, suggestion) {
      var labelKey = _this.props.labelKey;
      var query = _this.state.query;
      var newQuery = labelize(suggestion, labelKey) || query;
      _this.updateSelected(suggestion);
      _this.updateQuery(newQuery);
      // TODO: MH - Don't do this extra call.
      // Currently used to update the suggestions after suggestion selection.
      _this.handleSearchDebounced(_trimInstanceProperty(newQuery).call(newQuery));
    });
    _defineProperty(_assertThisInitialized(_this), "handleSuggestionClick", function (e, suggestion) {
      _this.handleSuggestionTabover(e, suggestion);
      _this.hideSuggestions();
    });
    _defineProperty(_assertThisInitialized(_this), "handleListNavigation", function (e) {
      var suggestions = _this.props.suggestions;
      var _this$state = _this.state,
        showSuggestions = _this$state.showSuggestions,
        activeIndex = _this$state.activeIndex;
      if (!showSuggestions) return;
      e.preventDefault();
      var newActiveIndex = activeIndex;

      // Increment or decrement index based on user keystroke.
      newActiveIndex += e.keyCode === UP ? -1 : 1;

      // If we've reached the end, go back to the beginning or vice-versa.
      if (newActiveIndex === suggestions.length) {
        newActiveIndex = -1;
      } else if (newActiveIndex === -2) {
        newActiveIndex = suggestions.length - 1;
      }
      _this.setState({
        activeIndex: newActiveIndex
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleEsc", function (e) {
      e.preventDefault();
      _this.hideSuggestions();
    });
    _defineProperty(_assertThisInitialized(_this), "handleTab", function (e) {
      var suggestions = _this.props.suggestions;
      var _this$state2 = _this.state,
        showSuggestions = _this$state2.showSuggestions,
        selected = _this$state2.selected;
      if (showSuggestions && suggestions.length > 0 && suggestions[0] !== selected) {
        _this.handleSuggestionTabover(e, suggestions[0]);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleReturn", function (e) {
      var suggestions = _this.props.suggestions;
      var _this$state3 = _this.state,
        showSuggestions = _this$state3.showSuggestions,
        activeIndex = _this$state3.activeIndex;
      if (!showSuggestions || activeIndex === -1) return;
      e.preventDefault();
      _this.handleSuggestionClick(e, suggestions[activeIndex]);
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var _handlers;
      var handlers = (_handlers = {}, _defineProperty2(_handlers, UP, _this.handleListNavigation), _defineProperty2(_handlers, DOWN, _this.handleListNavigation), _defineProperty2(_handlers, ESC, _this.handleEsc), _defineProperty2(_handlers, TAB, _this.handleTab), _defineProperty2(_handlers, RETURN, _this.handleReturn), _handlers);
      if (handlers[e.keyCode]) handlers[e.keyCode](e);
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var _this$props = _this.props,
        suggestions = _this$props.suggestions,
        onFocus = _this$props.onFocus;
      onFocus(e);
      _this.setState({
        showSuggestions: suggestions.length > 0
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderSuggestionList", function () {
      var activeIndex = _this.state.activeIndex;
      var _this$props2 = _this.props,
        renderSuggestionList = _this$props2.renderSuggestionList,
        classes = _this$props2.classes,
        rest = _objectWithoutProperties(_this$props2, _excluded);
      var suggestionListProps = _objectSpread(_objectSpread({}, rest), {}, {
        emptyLabel: _this.getEmptyLabel(),
        activeIndex: activeIndex,
        onSuggestionClick: _this.handleSuggestionClick
      });
      var containerContents = renderSuggestionList ? renderSuggestionList(suggestionListProps) : /*#__PURE__*/React.createElement(SuggestionList, _extends({
        classes: classes
      }, suggestionListProps));
      return /*#__PURE__*/React.createElement(SuggestionContainer, {
        classes: classes
      }, containerContents);
    });
    _this.state = AsyncTypeahead.getInitialState(props);
    return _this;
  }
  _createClass(AsyncTypeahead, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        activeIndex: this.state.activeIndex,
        onSuggestionClick: this.handleSuggestionClick
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.handleSearchDebounced = debounce(this.handleSearch, this.props.delay);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      var requestPending = this.state.requestPending;
      if (requestPending) {
        this.setState({
          requestPending: false
        });
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(query) {
      var _this2 = this;
      this.setState({
        requestPending: true
      }, function () {
        return _this2.props.onSearch(query);
      });
    }
  }, {
    key: "getEmptyLabel",
    value: function getEmptyLabel() {
      var _this$props3 = this.props,
        searchText = _this$props3.searchText,
        emptyLabel = _this$props3.emptyLabel;
      var requestPending = this.state.requestPending;
      return requestPending ? searchText : emptyLabel;
    }
  }, {
    key: "updateQuery",
    value: function updateQuery(query) {
      var onInputChange = this.props.onInputChange;
      this.setState({
        query: query
      });
      if (onInputChange) onInputChange(query);
    }
  }, {
    key: "updateSelected",
    value: function updateSelected(selected) {
      var onChange = this.props.onChange;
      this.setState({
        selected: selected
      });
      if (onChange) onChange(selected);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
        query = _this$state4.query,
        showSuggestions = _this$state4.showSuggestions,
        activeIndex = _this$state4.activeIndex;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        defaultInputValue = _this$props4.defaultInputValue,
        delay = _this$props4.delay,
        emptyLabel = _this$props4.emptyLabel,
        idKey = _this$props4.idKey,
        labelKey = _this$props4.labelKey,
        onInputChange = _this$props4.onInputChange,
        onSearch = _this$props4.onSearch,
        renderSuggestion = _this$props4.renderSuggestion,
        renderSuggestionList = _this$props4.renderSuggestionList,
        suggestions = _this$props4.suggestions,
        searchText = _this$props4.searchText,
        fieldClasses = _this$props4.fieldClasses,
        rest = _objectWithoutProperties(_this$props4, _excluded2);
      return /*#__PURE__*/React.createElement("div", {
        className: classes.container,
        onBlur: this.handleBlur
      }, /*#__PURE__*/React.createElement(Field, _extends({}, rest, {
        inputRef: this.inputRef,
        value: labelize(suggestions[activeIndex], labelKey) || query,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        classes: fieldClasses
      })), showSuggestions && this.renderSuggestionList());
    }
  }]);
  return AsyncTypeahead;
}(Component);
_defineProperty(AsyncTypeahead, "getInitialState", function (props) {
  return {
    query: props.defaultInputValue || '',
    showSuggestions: false,
    requestPending: false,
    activeIndex: -1,
    selected: null
  };
});
AsyncTypeahead.defaultProps = {
  defaultInputValue: null,
  delay: 200,
  emptyLabel: 'No matches found.',
  idKey: null,
  labelKey: 'label',
  onChange: null,
  onFocus: noop,
  onInputChange: null,
  onSearch: noop,
  renderSuggestion: null,
  renderSuggestionList: null,
  suggestions: [],
  searchText: 'Searching...'
};
process.env.NODE_ENV !== "production" ? AsyncTypeahead.propTypes = {
  /**
   * Specify the inputs default text.
   */
  defaultInputValue: PropTypes.string,
  /**
   * Delay, in milliseconds, before performing search.
   */
  delay: PropTypes.number,
  /**
   * Message to display in the menu if there are no valid results.
   */
  emptyLabel: PropTypes.string,
  /**
   * Specify the suggestion key to use for display or a function returning the display string.
   */
  labelKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Invoked whenever items is selected.
   */
  onChange: PropTypes.func,
  /**
   * Invoked when the input is focused. Receives an event.
   */
  onFocus: PropTypes.func,
  /**
   * Invoked when the input value changes.
   */
  onInputChange: PropTypes.func,
  /**
   * Callback to perform when the search is executed.
   */
  onSearch: PropTypes.func,
  /**
   * Provides a hook for customized rendering of suggestion item contents.
   */
  renderSuggestion: PropTypes.func,
  // TODO: Is this being used?
  /**
   * Provides a hook for customized rendering of the suggestions list.
   */
  renderSuggestionList: PropTypes.func,
  /**
   * Text displayed in the menu while the request is pending.
   */
  searchText: PropTypes.string,
  /**
   * Specify the suggestion key to use for uniquely identifying a suggestion.
   */
  idKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Full set of suggestions. Must either be an array of objects or strings.
   */
  suggestions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),
  /**
   * Classes dependencies
   */
  classes: classesPropType(['container', 'list-container', 'list', 'item', 'item-is-disabled', 'item-is-active']).isRequired,
  /**
   * Field Classes dependencies. See Field component for list of valid classes
   */
  fieldClasses: classesPropType()
} : void 0;
AsyncTypeahead.childContextTypes = {
  activeIndex: PropTypes.number.isRequired,
  onSuggestionClick: PropTypes.func.isRequired
};
export default withClasses(styles)(AsyncTypeahead);